import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltipRoleDisabled: {
		id: 'users-and-roles.common.roles-picker.option.tooltip-role-disabled',
		defaultMessage: 'A user must have at least 1 role assigned to them',
		description: 'Shown in the roles picker when user hovered over disabled role',
	},
});
